import { render, staticRenderFns } from "./DesktopBetaPage.vue?vue&type=template&id=138bce67&scoped=true"
import script from "./DesktopBetaPage.vue?vue&type=script&lang=ts"
export * from "./DesktopBetaPage.vue?vue&type=script&lang=ts"
import style0 from "./DesktopBetaPage.vue?vue&type=style&index=0&id=138bce67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138bce67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138bce67')) {
      api.createRecord('138bce67', component.options)
    } else {
      api.reload('138bce67', component.options)
    }
    module.hot.accept("./DesktopBetaPage.vue?vue&type=template&id=138bce67&scoped=true", function () {
      api.rerender('138bce67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DesktopBetaPage.vue"
export default component.exports